import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'arrayTableAdd',
    position: [ButtonPosition.arrayTableOperate],
    action: () => { },
};
